<template>
  <div ref="containerRef" :style="boxStyle" class="box">
    <video
      ref="videoRef"
      src=""
      autoplay
      muted
      loop
      res
      webkit-playsinline="true"
      x-webkit-airplay="true"
      playsinline="true"
      poster=""
      x5-playsinline
      @loadeddata="onLoadedmetadata"
      controls360="no"
      x5-video-player-type="h5"
      v-if="!isQuarkbrowser"
    />
    <VueLazyImg :src="coverUrl" alt="快影" v-else />
  </div>
</template>

<script setup lang="ts">
import VueLazyImg from '../VueLazyImg.vue'
const { boxStyle, videoUrl, coverUrl } = defineProps({
  videoUrl: {
    type: String,
    default: '',
  },
  coverUrl: {
    type: String,
    default: '',
  },
  boxStyle: {
    type: Object,
    default: () => {
      return {}
    },
  },
  pause: {
    type: Boolean,
    default: true,
  },
})
const videoRef = ref<HTMLVideoElement>()
const containerRef = ref<HTMLDivElement>()
const isQuarkbrowser = ref(false)
const setVideoDimensions = () => {
  if (videoRef.value && containerRef.value) {
    const w = videoRef.value.videoWidth
    const h = videoRef.value.videoHeight
    const videoRatio: any = (w / h).toFixed(2)
    const containerStyles = window.getComputedStyle(containerRef.value)
    const minW = parseInt(containerStyles.getPropertyValue('width'))
    const minH = parseInt(containerStyles.getPropertyValue('height'))
    const widthRatio = minW / w
    const heightRatio = minH / h
    let newWidth: number
    let newHeight: number
    if (widthRatio > heightRatio) {
      newWidth = minW
      newHeight = Math.ceil(newWidth / videoRatio)
    } else {
      newHeight = minH
      newWidth = Math.ceil(newHeight * videoRatio)
    }
    videoRef.value.style.width = newWidth + 'px'
    videoRef.value.style.height = newHeight + 'px'
  }
}
const onLoadedmetadata = () => {
  setVideoDimensions()
}
function checkIsInView(element?: HTMLVideoElement) {
  const observer = new IntersectionObserver((entries) => {
    const entry = entries[0]
    if (entry.isIntersecting) {
      if (videoRef.value) {
        if (videoRef.value.src !== videoUrl) {
          videoRef.value.src = videoUrl
          videoRef.value.poster = coverUrl
        }
        videoRef.value.play()
      }
    } else {
      if (videoRef.value) {
        if (videoRef.value.src === videoUrl) {
          videoRef.value.pause()
        }
      }
    }
  })
  if (element) {
    observer.observe(element)
  }
}

onMounted(() => {
  setVideoDimensions()
  checkIsInView(videoRef.value)
  window.addEventListener('resize', setVideoDimensions, false)
  isQuarkbrowser.value = /quark/i.test(navigator.userAgent.toLowerCase())
})
</script>
<style scoped>
video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.box {
  overflow: hidden;
}
</style>
